"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Footer = void 0;
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
require("./Footer.scss");
var ContactBar_1 = require("../sidebar/ContactBar");
var Footer = /** @class */ (function (_super) {
    __extends(Footer, _super);
    function Footer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Footer.prototype.componentDidUpdate = function (prevProps) {
        var appElement = document.getElementById('app');
        if (this.props.isLoggedIn && !prevProps.isLoggedIn) {
            if (appElement) {
                appElement.classList.add('logged-in');
            }
        }
        else if (!this.props.isLoggedIn && prevProps.isLoggedIn) {
            if (appElement) {
                appElement.classList.remove('logged-in');
            }
        }
    };
    Footer.prototype.render = function () {
        return (react_1.default.createElement("div", { className: classnames_1.default('mobile-footer', { 'is-hidden': !this.props.isLoggedIn }, 'is-hidden-tablet', 'is-hidden-desktop', 'is-hidden-widescreen', 'is-hidden-fullhd') },
            react_1.default.createElement(ContactBar_1.ContactBar, { asperaVersion: this.props.asperaVersion, isMobile: true })));
    };
    return Footer;
}(react_1.Component));
exports.Footer = Footer;
var mapStateToProps = function (state) {
    return {
        asperaVersion: state.transfers.connectVersion,
        isLoggedIn: !!state.auth.userInfo
    };
};
exports.default = react_redux_1.connect(mapStateToProps)(Footer);
